/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './slice';
/**
 * Getting entire user invites state into the component
 */
const selectDomain = (state) => state['feature/user-invites'] || initialState;
/**
 * Getting the loader state into the component
 */
export const selectLoader = createSelector(
  [selectDomain],
  (userInvitesState) => userInvitesState?.loading
);

/**
 * Getting user invite list list state into the component
 */
export const selectUserInvitesList = createSelector(
  [selectDomain],
  (userInvitesState) => userInvitesState?.userInvitesList
);
/**
 * Getting the users list state into the component
 */
export const selectUsers = createSelector(
  [selectDomain],
  (userInvitesState) => userInvitesState?.usersList
);
/**
 * Getting the roles list state into the component
 */
export const selectRoleList = createSelector(
  [selectDomain],
  (userInvitesState) => userInvitesState?.roleList
);
